<template>
  <div
    v-html="$$FormData.content || default_content"
    class="rich-text"
    :class="{'rich-text__full-screen': $$FormData.full_screen}"
    :style="{
      backgroundColor: $$FormData.background_color
    }"
  ></div>
</template>

<script>
// TODO: 配置未完善
export default {
  name: 'RichTextPreview',
  data() {
    return {
      default_content: `<p style="text-align: center;"><strong>来下五子棋呀</strong></p><table width="291"><tbody><tr class="firstRow"><td width="11" valign="top" style="word-break: break-all;">                ⚪️<br/></td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚪️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top"></td><td valign="top" colspan="1" rowspan="1" width="null">                ⚪️</td><td valign="top" colspan="1" rowspan="1">                ⚫️</td></tr><tr><td width="11" valign="top"></td><td width="11" valign="top"></td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚪️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚫️</td><td valign="top" colspan="1" rowspan="1" width="null"></td><td valign="top" colspan="1" rowspan="1"></td></tr><tr><td width="11" valign="top"></td><td width="11" valign="top"></td><td width="11" valign="top">                ⚪️</td><td width="11" valign="top" style="word-break: break-all;">                ⚪️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚪️</td><td width="11" valign="top"></td><td valign="top" colspan="1" rowspan="1" width="null">                ⚫️</td><td valign="top" colspan="1" rowspan="1"></td></tr><tr><td width="11" valign="top"></td><td width="11" valign="top"></td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚪️</td><td width="11" valign="top"></td><td width="11" valign="top"></td><td valign="top" colspan="1" rowspan="1" width="null"></td><td valign="top" colspan="1" rowspan="1">                ⚪️</td></tr><tr><td width="11" valign="top"></td><td width="11" valign="top"></td><td width="11" valign="top">                ⚪️</td><td width="11" valign="top">                ⚪️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top"></td><td width="11" valign="top"></td><td valign="top" colspan="1" rowspan="1" width="null"></td><td valign="top" colspan="1" rowspan="1"></td></tr><tr><td width="11" valign="top"></td><td width="11" valign="top"></td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚫️</td><td width="11" valign="top">                ⚪️</td><td width="11" valign="top"></td><td width="11" valign="top"></td><td valign="top" colspan="1" rowspan="1" width="null"></td><td valign="top" colspan="1" rowspan="1"></td></tr></tbody></table>`
    }
  }
}
</script>

<style lang="scss" scoped>
.rich-text {
  position: relative;
  box-sizing: border-box;
  padding: 10px 10px 0;
  overflow: hidden;
  color: #333;
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  word-wrap: break-word;
  &__full-screen {
    margin-top: 0;
    padding: 0;
  }
  /deep/ {
    img+br {
      display: block;
      padding: 4px 0;
      content: " "
    }
    p {
      margin: 0 0 1em
    }
    .Powered-by-XIUMI p {
      margin: 0
    }
    a {
      color: #07d
    }
    img {
      max-width: 100%!important;
      min-height: 1px;
      vertical-align: bottom;
      background: 0 0
    }
    img,
    & ol {
      width: auto!important
    }
    blockquote {
      margin: 0 0 18px;
      padding: 0 0 0 15px;
      border-left: 5px solid #eee
    }
    em,
    & i {
      font-style: italic
    }
    b,
    & strong {
      font-weight: 700
    }
    .selectTdClass {
      background-color: #edf5fa!important
    }
    table.noBorderTable caption,
    & table.noBorderTable td,
    & table.noBorderTable th {
      border: 1px dashed #ddd!important
    }
    table {
      display: table;
      width: auto!important;
      margin: 0 auto 10px;
      border-collapse: collapse
    }
    td,
    & th {
      padding: 5px 10px;
      border: 1px solid #ddd
    }
    caption {
      padding: 3px;
      text-align: center;
      border: 1px dashed #ddd;
      border-bottom: 0
    }
    th {
      background: #f7f7f7;
      border-top: 2px solid #bbb
    }
    td p {
      margin: 0;
      padding: 0
    }
    .ue-table-interlace-color-single {
      background-color: #fcfcfc
    }
    .ue-table-interlace-color-double {
      background-color: #f7faff
    }
    .bottom-floating-banner {
      position: fixed!important;
      bottom: 0
    }
    .list-paddingleft-2 {
      padding-left: 30px
    }
    &--fullscreen {
      margin-top: 0;
      padding: 0
    }
    .edui-faked-video {
      width: 100%
    }
  }
}
</style>
